import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { Label } from '@/common/ui/label'
import { IntervalCondition } from '../../types'
import {
	INTERVAL_CONDITION_LABELS,
	DAY_OF_WEEK_OPTIONS,
} from '../../utils/conditionLabels'
import { generateDateOfMonthOptions } from '../../utils/intervalHelpers'

interface IntervalConditionSelectorProps {
	intervalCondition: IntervalCondition
	intervalValue: number
	onIntervalConditionChange: (condition: IntervalCondition) => void
	onIntervalValueChange: (value: number) => void
	disabled?: boolean
}

export const IntervalConditionSelector = ({
	intervalCondition,
	intervalValue,
	onIntervalConditionChange,
	onIntervalValueChange,
	disabled,
}: IntervalConditionSelectorProps) => {
	const dateOfMonthOptions = generateDateOfMonthOptions()

	return (
		<div className="space-y-4">
			<div className="space-y-2">
				<Label>ประเภทช่วงเวลา</Label>
				<Select
					value={intervalCondition}
					onValueChange={(value) =>
						onIntervalConditionChange(value as IntervalCondition)
					}
					disabled={disabled}
				>
					<SelectTrigger>
						<SelectValue placeholder="เลือกประเภทช่วงเวลา" />
					</SelectTrigger>
					<SelectContent>
						{Object.entries(INTERVAL_CONDITION_LABELS).map(([key, label]) => (
							<SelectItem key={key} value={key}>
								{label}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>

			<div className="space-y-2">
				{intervalCondition === IntervalCondition.DAY_OF_WEEK ? (
					<>
						<Label>เลือกวันในสัปดาห์</Label>
						<Select
							value={intervalValue.toString()}
							onValueChange={(value) => onIntervalValueChange(Number(value))}
							disabled={disabled}
						>
							<SelectTrigger>
								<SelectValue placeholder="เลือกวัน" />
							</SelectTrigger>
							<SelectContent>
								{DAY_OF_WEEK_OPTIONS.map((day) => (
									<SelectItem key={day.value} value={day.value.toString()}>
										{day.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					</>
				) : (
					<>
						<Label>เลือกวันที่ของเดือน</Label>
						<Select
							value={intervalValue.toString()}
							onValueChange={(value) => onIntervalValueChange(Number(value))}
							disabled={disabled}
						>
							<SelectTrigger>
								<SelectValue placeholder="เลือกวันที่" />
							</SelectTrigger>
							<SelectContent>
								{dateOfMonthOptions.map((date) => (
									<SelectItem key={date.value} value={date.value.toString()}>
										{date.label}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					</>
				)}
			</div>
		</div>
	)
}
